'use strict';

/**
 * Modal for entering the Voucher code
 *
 * @category   View
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 */

var LayoutView = require('base/Colido.LayoutView');

var template = require('../../../templates/layout/subscription/voucher-modal.hbs');

var VoucherModalView = LayoutView.extend({
    template: template,

    ui: {
        actionClose: '[data-action="close"]',
        form: 'form',
        voucherCodeInput: 'form input[name="voucherCode"]',
        verifyButton: 'form .btn[type="submit"]',
        responseContainer: '.voucher-response',
        responseText: '.voucher-response p',
    },

    events: {
        'click @ui.actionClose': 'onActionClose',
        'submit @ui.form': 'onSubmitForm',
        'click button[data-action="change-plan"]': 'onChangePlan',
    },

    /**
     * Is triggered, when the modal should be closed
     * @param {object} event The click event
     */
    onActionClose: function(event) {
        this.trigger('close:modal');
    },

    /**
     * Is triggered, when the form is submitted
     * @param {object} event The submit event
     */
    onSubmitForm: function(event) {
        event.preventDefault();
        this.ui.responseContainer.toggleClass('has-response', false);
        this.ui.voucherCodeInput.toggleClass('has-error', false);

        if (this.ui.voucherCodeInput.val().length > 0) {
            this.ui.verifyButton.toggleClass('is-loading', true).prop('disabled', true);

            // Save voucher
            var xhr = this.model.save({
                voucherCode: this.ui.voucherCodeInput.val(),
            }, {
                patch: true,
                wait: true,
                success: function(model, response) {
                    this.trigger('close:modal', {valid: true});
                }.bind(this),
                error: function(model, response) {
                    if (response && response.responseJSON && response.responseJSON.message) {
                        this.ui.responseContainer.toggleClass('has-response', true);
                        this.ui.voucherCodeInput.toggleClass('has-error', true);

                        var message = response.responseJSON.message.replace(/_/g, '-').toLowerCase();
                        if (message === 'code-invalid-for-selected-plan') {
                            this.ui.responseText.html(App.t('subscription::setup:voucher:text:response:' + message, {
                                link: '<button type="button" class="link link-border" data-action="change-plan">' +
                                      App.t('subscription::setup:link:change-your-plan') +
                                      '</button>',
                            }));
                        } else {
                            this.ui.responseText.html(App.t('subscription::setup:voucher:text:response:' + message));
                        }
                    }
                }.bind(this),
            }).always(function() {
                this.ui.verifyButton.toggleClass('is-loading', false).prop('disabled', false);
            }.bind(this));
        } else {
            this.ui.voucherCodeInput.toggleClass('has-error', true);
        }
    },

    /**
     * Focus voucher input on show
     */
    onShow: function() {
        _.delay(function() {
            this.ui.voucherCodeInput.focus();
        }.bind(this), 100);
    },

    /**
     * Is triggered, when the user want's to change the plan
     */
    onChangePlan: function() {
        App.radio('subscription:setup').trigger('change:plan');
        this.trigger('close:modal');
    },
});

module.exports = VoucherModalView;